// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".writeTypeBtnStyle{float:left;width:calc(33% - 10px);height:95px;cursor:pointer;border-radius:6px;position:relative;border:3px solid #f4f4f4;display:flex;flex-direction:column;justify-content:center;align-items:center}.widthChange{width:calc(50% - 10px)!important}.noneClickCSS{border-radius:6px;position:absolute;background:rgba(0,0,0,.18823529411764706)}", ""]);
// Exports
module.exports = exports;
